import { Injectable } from '@angular/core';
import { HttpServiceService } from './http-service.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class FiledsService {
  public ListFieldValuesClientURL = "Fields/GetListFieldValuesClient"


  constructor(private http: HttpServiceService, private config: ConfigService) { }

  ListFieldValues(Type, ParentId, token) {

    return new Promise((reslove, reject) => {

      this.http.postToCloseApi(this.config.server + this.ListFieldValuesClientURL, { Type: Type, ParentId: ParentId }, token).subscribe((res: any) => {

        reslove(res)

      },
        (Error) => {
          reslove(Error)
        }
      );
    });
  }
}
